import type { ContentfulSysProps } from '../../types/contentful';
import type { CarouselV3DataProps } from '../CarouselV3';

export const isCarouselV3 = (props?: ContentfulSysProps): props is CarouselV3DataProps => {
  return (props as CarouselV3DataProps)?.__typename === 'CarouselV3';
};
